import { ActionTypes } from "../../../OrderFlowProvider/OrderFlowActionTypes";
export var WeekQuantityText;
(function (WeekQuantityText) {
    WeekQuantityText["InvalidConfiguration"] = "Invalid Week Quantity module configuration";
})(WeekQuantityText || (WeekQuantityText = {}));
export const handleDispatchWeekQuantity = (dispatch) => (event) => {
    dispatch({ type: ActionTypes.SET_WEEK_QUANTITY, payload: event.currentTarget.value });
    dispatch({ type: ActionTypes.SET_RECIPE_FETCH_STATUS, payload: { completed: false, error: false } });
};
